
import { ref } from "vue"
import { useInformation } from "@/store/store";

export default {
  setup(){
    const { setMessage } = useInformation();

    const modal = ref(false);

    const open = () => {
      modal.value = true
      setMessage('You opened modal.')
    }

    const close = () => {
      modal.value = false
      setMessage('You closed modal.')
    }

    return {
      open,
      close,
      modal
    }
  }
}
